import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";
import dateTimeHelper from "../../../Helpers/datetimeHelper";

export default class ExchangeRateSearchParams extends SearchParamsBase
{
	initialize ()
	{
		this.CurrencyId = 0;
		this.DateTimeFrom = dateTimeHelper.indefiniteDateValue();
		this.DateTimeTo = dateTimeHelper.indefiniteDateValue();
		this.Type = "";
	}

	static fieldsInSearchBox = [
		{ fieldName: "DateTimeFrom", label: "Date From", className: "col-6", type: InputTypesEnum.DateWithIndefinite },
		{ fieldName: "DateTimeTo", label: "Date To", className: "col-6", type: InputTypesEnum.DateWithIndefinite },
	];

	static iconName = "fa-solid fa-search";
	static saveType = "ExchangeRateSearchParams";
}